export interface CommonError {
  readonly innerError: Error;
}
